import { render, staticRenderFns } from "./GoodsPay.vue?vue&type=template&id=56916f71&scoped=true&"
import script from "./GoodsPay.vue?vue&type=script&lang=js&"
export * from "./GoodsPay.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPay.vue?vue&type=style&index=0&id=56916f71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56916f71",
  null
  
)

export default component.exports